import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import { StatusChip } from "@itandi/itandi-bb-ui/StatusChip";
import { Table } from "@itandi/itandi-bb-ui/Table";
import { Tbody } from "@itandi/itandi-bb-ui/Tbody";
import { Td } from "@itandi/itandi-bb-ui/Td";
import { TextLink } from "@itandi/itandi-bb-ui/TextLink";
import { Th } from "@itandi/itandi-bb-ui/Th";
import { Thead } from "@itandi/itandi-bb-ui/Thead";
import { Tr } from "@itandi/itandi-bb-ui/Tr";
import { formatDate } from "@itandi/tools/vanilla";
import { useDealContext } from "~/context/DealContext";
import { useDealWorkflows } from "~/hooks/deals/useDealWorkflows";
import {
	DEAL_WORKFLOW_STATUS_CHIP,
	isAfterTheFactApprovalWorkflow
} from "~/models/DealWorkflow";
import { itandiTaskWorkflowUrl } from "~/utils/ItandiTaskPath";

export function DealWorkflowTable() {
	const deal = useDealContext();
	const { notify } = useNotification();
	const { data: workflows, isLoading } = useDealWorkflows(deal.id, () => {
		notify({
			content: "ワークフローの取得に失敗しました。",
			variant: "error"
		});
	});

	return (
		<Table>
			<Thead>
				<Tr>
					<Th>ワークフロー名</Th>
					<Th>事後承認</Th>
					<Th>申請者</Th>
					<Th>申請日</Th>
					<Th>ステータス</Th>
					<Th>現在のステップ</Th>
					<Th>コメント</Th>
				</Tr>
			</Thead>
			<Tbody loading={isLoading}>
				{workflows?.map((workflow) => (
					<Tr key={workflow.id}>
						<Td>
							<TextLink
								color="link"
								href={itandiTaskWorkflowUrl(workflow.id)}
								target="_blank"
								weight="bold"
							>
								{workflow.name}
							</TextLink>
						</Td>
						<Td>
							{isAfterTheFactApprovalWorkflow(workflow) ? "事後承認" : null}
						</Td>
						<Td>{workflow.applicantName}</Td>
						<Td>{formatDate(workflow.createdAt)}</Td>
						<Td>
							<StatusChip
								variant={DEAL_WORKFLOW_STATUS_CHIP[workflow.status].variant}
							>
								{DEAL_WORKFLOW_STATUS_CHIP[workflow.status].label}
							</StatusChip>
						</Td>
						<Td>{workflow.currentStep?.name}</Td>
						<Td>{workflow.latestTaskComment}</Td>
					</Tr>
				))}
			</Tbody>
		</Table>
	);
}
